type GlyphsEntity = {
    css: string
    code: number
}

export type FontelloConfig = {
    name: string
    css_prefix_text: string
    css_use_suffix: boolean
    hinting: boolean
    units_per_em: number
    ascent: number
    glyphs?: GlyphsEntity[] | null
}

let fontelloConfig: FontelloConfig

export const changeFontelloConfig = (newConfig: FontelloConfig): void => {
    fontelloConfig = newConfig
}

export const getFontFamily = (): string => fontelloConfig.name

export default (name: string): number | null => {
    const glyph =
        fontelloConfig &&
        fontelloConfig.glyphs &&
        fontelloConfig.glyphs.find((item: GlyphsEntity): boolean => item.css === name)

    return glyph ? glyph.code : null
}
